import DeleteIcon from '@mui/icons-material/Delete';
import { Typography, Box, Radio, FormControlLabel, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import apiReq from 'core/api';
import { useSnackbar, globalConfirm } from '../../components/GlobalSnackbar';
import Loader from '../../components/Loader';

// Styled Radio (Optional)
const StyledRadio = styled(Radio)({
  color: '#1976d2',
  '&.Mui-checked': {
    color: '#1976d2',
  },
});

export default function SamplesTTList({ onSelectSampleTT, reloadKey }) {
  const currProject = useSelector((state) => state.reducer.project.id);
  const showSnackbar = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);
  const [samplesData, setSamplesData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const getData = useCallback(() => {
    setIsLoading(true);
    apiReq(`projects/documents?project_id=${currProject}`, 'get')
      .then((res) => {
        setSamplesData(res);
        if (res?.length) {
          const selectedSample = res.find((item) => item.is_active);
          if (selectedSample) {
            setSelectedId(selectedSample.id);
          }
        }

        setIsLoading(false);
      })
      .finally(() => setIsLoading(false));
  }, [currProject]);

  useEffect(() => {
    if (currProject) {
      getData();
      setSelectedId(null); // сбрасываем выбранное при смене проекта
    }
  }, [currProject, getData, reloadKey]);

  useEffect(() => {
    onSelectSampleTT(!!selectedId);
  }, [selectedId, onSelectSampleTT]);

  const handleDelete = (item) => {
    globalConfirm({
      message: `Удалить образец "${item.name}"?`,
      confirmText: 'Удалить',
      cancelText: 'Отмена',
      onConfirm: async () => {
        setIsLoading(true);
        try {
          await apiReq(`projects/documents/delete?document_id=${item.id}`, 'delete');
          setSamplesData((prev) => prev.filter((el) => el.id !== item.id));
          if (selectedId === item.id) {
            setSelectedId(null);
          }
          showSnackbar({ message: 'Образец удалён', severity: 'success' });
        } catch {
          showSnackbar({ message: 'Ошибка при удалении', severity: 'error' });
        } finally {
          setIsLoading(false);
        }
      },
    });
  };

  const handleRadio = (event, currentDoc) => {
    setSelectedId(currentDoc.id);
    if (!currentDoc.is_active) {
      apiReq(`projects/documents/toggle?document_id=${currentDoc.id}`, 'post');
    }
    setSamplesData(
      samplesData.map((item) => {
        item.is_active = item.id === currentDoc.id;
        return item;
      })
    );
  };

  return (
    <>
      {currProject && (
        <>
          {isLoading && <Loader />}
          {!isLoading && (
            <>
              {samplesData.length > 0 && (
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    wordBreak: 'break-word',
                    lineHeight: '18px',
                    marginTop: '10px',
                  }}
                >
                  {samplesData.map((item) => (
                    <Box
                      key={item.id}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <FormControlLabel
                        control={
                          <StyledRadio
                            checked={selectedId === item.id || item.is_active}
                            onChange={(e) => handleRadio(e, item)}
                          />
                        }
                        label={item.name}
                        sx={{ flex: 1, margin: 0 }}
                      />
                      <IconButton
                        size="small"
                        aria-label="delete-sample"
                        onClick={() => handleDelete(item)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}
                </Box>
              )}

              {samplesData?.length === 0 && (
                <Typography variant="body2" color="textSecondary">
                  Нет образцов ТЗ
                </Typography>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}
